import TkHelpIcon from "../../components/atoms/TkHelpIcon";

const help1 = (
  <>
    被共済職員期間が１年以上（12か月以上）ある場合に退職手当金を請求することができます。
    <br />
    被共済職員期間が１年未満（12か月未満）の場合は、退職手当金は請求できませんが、１年以上在籍されている場合は、合算制度を利用することが可能です。
  </>
);

const help2 = (
  <>
    この制度は、退職手当金を請求しないで退職した日から起算して３年以内の間に、再び被共済職員となり機構に申し出た場合に、被共済職員期間を合算することができます。
    <br />※
    退職した場合、退職手当金の請求、あるいは、この制度（被共済職員期間を合算する制度）の利用のいずれかを選択できます。
    <br />
    ただし、次のいずれかに該当するときは、期間の合算はできません。
    <br />・ 退職手当金を請求したとき
    <br />
    ・ 退職日を含めて、被共済職員としての期間が１年未満のとき
    <br />・
    退職した理由が、自己の犯罪行為その他これに準ずべき重大な非行であった場合
    <br />
    ※上記のほか、虚偽報告その他、法の規定により期間の合算ができない場合があります。
    <br />
    ※３年以内の間に再び被共済職員とならなかった場合は、改めて退職手当金の請求手続きを行う必要があります。
    <br />
    インターネット上でお手続きをされる場合は、画面の最後に表示される「引継ぎコード」を次の就職先の担当者へお伝えください。
    <br />
    紙でお手続きをされる場合は、様式をダウンロードいただき、必要事項をご記入後、機構へご提出ください。
  </>
);

const explanatoryText = (
  <>
    「退職手当金」を請求する場合は
    <TkHelpIcon helpMessage={help1} />
    、「退職手当金を請求」ボタン、 「合算制度 <TkHelpIcon helpMessage={help2} />
    」を利用する場合は「合算制度を利用」ボタンを押してください。
    <br />
    退職手当金のシミュレーションも可能ですので、ご確認の上、選択してください。
  </>
);

export { explanatoryText, help1, help2 };
